export default __webpack_public_path__ + "static/media/fruit-768w.bff42a75.avif";